import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { EquipmentModel } from '../../../../models/equipment.model';
import { SiteModel } from '../../../../models/site.model';
import { UnityModel } from '../../../../models/unity.model';

@Component({
    selector: 'app-breadcrumb',
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit, OnChanges {
    @Input() item!: EquipmentModel | SiteModel | UnityModel | undefined;
    @Input() type!: 'equipment' | 'site' | 'unity';

    equipmentItem?: EquipmentModel;
    siteItem?: SiteModel;
    unityItem?: UnityModel;

    ngOnInit() {
        this.updateItem();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.item || changes.type) {
            this.updateItem();
        }
    }

    private updateItem() {
        if (this.type === 'equipment') {
            this.equipmentItem = this.item as EquipmentModel;
        } else if (this.type === 'site') {
            this.siteItem = this.item as SiteModel;
        } else if (this.type === 'unity') {
            this.unityItem = this.item as UnityModel;
        }
    }
}
